var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08589 0.855082C6.22652 0.714632 6.41714 0.635742 6.61589 0.635742C6.81464 0.635742 7.00527 0.714632 7.14589 0.855082L11.3959 5.10508C11.5363 5.24571 11.6152 5.43633 11.6152 5.63508C11.6152 5.83383 11.5363 6.02446 11.3959 6.16508L7.14589 10.4151C7.00363 10.5475 6.81558 10.6196 6.62126 10.6162C6.42695 10.6129 6.2415 10.5343 6.10389 10.3971C5.96665 10.2595 5.8881 10.074 5.88474 9.87971C5.88138 9.68539 5.95349 9.49734 6.08589 9.35508L9.05589 6.38508L1.61589 6.38508C1.41698 6.38508 1.22622 6.30606 1.08556 6.16541C0.944912 6.02476 0.865894 5.83399 0.865894 5.63508C0.865894 5.43617 0.944912 5.2454 1.08556 5.10475C1.22622 4.9641 1.41698 4.88508 1.61589 4.88508L9.05589 4.88508L6.08589 1.91508C5.94544 1.77446 5.86655 1.58383 5.86655 1.38508C5.86655 1.18633 5.94544 0.995707 6.08589 0.855082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c8925cfcf1bf65e24b05cf3d43d186e8.svg";
export { ForwardRef as ReactComponent };